<ba-bub-feedback
  [clientId]="'bf9ce766-b7c4-403f-9a97-3ba38e6de229'"
  [subject]="'Feedback zur Studiensuche'"
  [customHeader]="header"
>
</ba-bub-feedback>
<ng-template #header>
  <div slot="header" class="h5">Wie gefällt Ihnen die Studiensuche?</div>
</ng-template>
